module.exports = __webpack_public_path__ + "static/img/gem.50ae9039.svg";